import React from "react";
import { Row, Text, Icon } from "@amzn/meridian";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";

interface ProgressBreadcrumbProps {
  steps: string[];
  currentStep: number; // 0-indexed
}

/**
 * Progress breadcrumb component showing multi-step workflow
 * Shows all steps with current step highlighted
 */
const ProgressBreadcrumb: React.FC<ProgressBreadcrumbProps> = ({
  steps,
  currentStep,
}) => {
  return (
    <Row spacing="100" alignmentVertical="center" spacingInset="none none 300 none">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <Text
            type={index === currentStep ? "b300" : "b200"}
            color={index === currentStep ? "primary" : index < currentStep ? "success" : "secondary"}
          >
            {step}
          </Text>
          {index < steps.length - 1 && (
            <Icon 
              tokens={chevronRightSmallTokens} 
              color={index < currentStep ? "success" : "secondary"}
            />
          )}
        </React.Fragment>
      ))}
    </Row>
  );
};

export default ProgressBreadcrumb;
